import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { TextField as Core} from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';

//import actions
import { alertAction } from "../../redux/actions";

/**
 * Import Component
 * @param {*} props
 */
function ImportComponent({ classes, name, id, className, value, handleChange, accept, ...rest }) {

  // Define Dispatch
  const dispatch = useDispatch();

  //handle image upload
// handle image upload
const imageHandler = (e) => {
  const regEx = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;

  if (e.target.files && e.target.files[0]) {
    const fileSize = e.target.files[0]["size"];
    const fNamee = e.target.files[0].name ? e.target.files[0].name.toString() : "";

    if (fileSize > (5 * 1024 * 1024)) {
      dispatch(alertAction.error("File size should be less than 5MB"));
    } else if (!regEx.exec(fNamee)) {
      dispatch(alertAction.error("File type not allowed"));
    } else {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.onload = (event) => {
        const arrayBuffer = event.target.result;
        const uint8Array = new Uint8Array(arrayBuffer);
        const pdfText = new TextDecoder("utf-8").decode(uint8Array);
        
        let isValidFile = false;

        if (fNamee.endsWith('.png')) {
          isValidFile = uint8Array[0] === 0x89 && uint8Array[1] === 0x50 &&
                        uint8Array[2] === 0x4E && uint8Array[3] === 0x47;
        } 
        else if (fNamee.endsWith('.jpg') || fNamee.endsWith('.jpeg')) {
          isValidFile = uint8Array[0] === 0xFF && uint8Array[1] === 0xD8;
        } 
        else if (fNamee.endsWith('.pdf')) {
          isValidFile = uint8Array[0] === 0x25 && uint8Array[1] === 0x50 &&
                        uint8Array[2] === 0x44 && uint8Array[3] === 0x46;

          if (isValidFile) {
            // Check PDF structure
            const headerIsPresent = pdfText.startsWith("%PDF-");
            const hasXRef = pdfText.includes("xref");
            const hasTrailer = pdfText.includes("trailer");
            const hasEOF = pdfText.includes("%%EOF");
            const eofPosition = pdfText.lastIndexOf("%%EOF");
            const fileLength = pdfText.length;
            const hasStartXref = pdfText.includes("startxref");

            // Ensure EOF is near the end and essential sections are present
            const eofIsAtEnd = fileLength - eofPosition < 100;
            const requiredOrder = headerIsPresent && hasXRef && hasTrailer && hasStartXref && eofIsAtEnd;

            // Confirm basic structure
            isValidFile = requiredOrder && hasEOF;
          }
        }

        if (isValidFile) {
          const validReader = new FileReader();
          validReader.onload = () => {
            handleChange({ name: name, value: validReader.result, val: fNamee });
          };
          validReader.readAsDataURL(file);
        } else {
          dispatch(alertAction.error(`Upload failed! The file "${fNamee}" is corrupted, Please check and try again`));
        }
      };

      reader.onerror = () => {
        dispatch(alertAction.error(`Upload failed! The file "${fNamee}" is corrupted, Please check and try again`));
      };

      reader.readAsArrayBuffer(file);
    }
  }
};


  const clickRoute = () => {
    try {
      if (document.getElementsByName(name) && document.getElementsByName(name)[0]) {
        document.getElementsByName(name)[0].click()
      } else {
        console.log("upload comp else");
      }
    } catch (err) {
      console.log("upload comp err");
    }
  }

  return (
    <React.Fragment>
      <Core
        id={"sa" + id}
        name={name + "tet"}
        className={"importField mt3"}
        onClick={(e) => { clickRoute() }}
        InputProps={{
          endAdornment:
            <React.Fragment>
              <FolderIcon />

            </React.Fragment>
        }}
        value={value}
        {...rest}
      />
      <label>
        <input
          name={name}
          id={id}
          className={`${classes.uploadImgPopup} ${classes.uploadImgOpacity}`}
          id="file-input"
          onChange={(e) => { imageHandler(e) }}
          type="file"
          style={{ display: "none" }}
          accept={accept}
        />
      </label>
    </React.Fragment>
  );
}

// default props
ImportComponent.defaultProps = {
  classes: {},
  className: "",
  handleChange: () => { },
  accept: ".png,.jpeg,.jpg,application/pdf",
  value: "",
  name: "",
  id: "",
  fullWidth: true,
  variant: 'outlined'
};

// prop types
ImportComponent.propTypes = {
  children: PropTypes.any,
  handleChange: PropTypes.func,
  classes: PropTypes.object,
  className: PropTypes.string,
  accept: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,

};

/** Export Component */
export const ImportFile = ImportComponent;
